
import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'blueassist';

  constructor(private translateService: TranslateService) { 
    const languages: { id: string, text: string }[] = [
			{ id: 'en', text: 'English' },
			{ id: 'es', text: 'Español' }
		];
    this.translateService.addLangs(languages.map(l => l.id));

    this.translateService.setDefaultLang(languages[0].id);
    this.translateService.use(localStorage.getItem('currentLang') || languages[0].id);

    localStorage.setItem('langs', JSON.stringify(languages));
  }
}